
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import PublicFilters from '@/components/filters/Public.vue';
import { useStore } from '@/plugins/store';
import ChartGrid from '@/views/Courses/ChartGrid.vue';
import CoursesTable from '@/views/Courses/CoursesTable.vue';

export default defineComponent({
    components: { PublicFilters, ChartGrid, CoursesTable },
    computed: {
        ...mapState(useStore, ['courses', 'regions', 'ageRanges', 'timePeriods', 'genders', 'statistics', 'focusStatistics']),
        ...mapWritableState(useStore, ['selectedPeriod', 'selectedAgeRange', 'selectedCourse', 'selectedRegions', 'selectedGender']),
    },
});
